exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".name-title-wrapper {\n    width: 70%;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center;\n    border-bottom: 1px black solid;\n}\n\nh1 {\n    margin-bottom: 0;\n}\n\nh4 {\n    margin-top: 0;\n}\n\ndiv {\n    color: black;\n    font-family: 'Montserrat', sans-serif;\n}\n\n.name-title-wrapper a {\n    text-decoration-line: none;\n    color: black;\n}\n\n.name-title-wrapper a .nameAndSubtitle {\n    transition: .5s ease;\n}\n\n.name-title-wrapper a:hover .nameAndSubtitle{\n    opacity: .5;\n}", ""]);

// exports
